import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

/**
 * Register.tsx - Enhanced to handle referral codes and redirect appropriately
 *
 * This page serves as the entry point for user registration and handles referral codes.
 * It redirects authenticated users to the Settings page and unauthenticated users to
 * the SignUp page while preserving referral codes in the URL.
 */
export default function Register() {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (isAuthenticated) {
      // Redirect authenticated users to the settings page
      navigate('/settings');
    } else {
      // Extract referral code from URL parameters
      const referralCode = searchParams.get('ref');

      if (referralCode) {
        // Redirect to signup with referral code preserved
        navigate(`/signup?ref=${encodeURIComponent(referralCode)}`);
      } else {
        // Redirect unauthenticated users to sign up without referral code
        navigate('/signup');
      }
    }
  }, [isAuthenticated, navigate, searchParams]);

  // This component just handles redirection
  return null;
}
